import { createContext, useContext } from "react";

const DashboardGateContext = createContext({
  planExpired: null,
  setPlanExpired: () => {},
});

export const DashboardGateProvider = DashboardGateContext.Provider;

export function useDashboardGate() {
  return useContext(DashboardGateContext);
}
